import styled from 'styled-components';

export const CoverageMessage = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sizing-xs);
`;
